export const AnalyticEventNames = Object.freeze({
    WEB_POPULAR_CLICK: 'web_popular_click',
    WEB_SELECT_CATEGORY: 'web_select_category',
    WEB_CLEAR_CATEGORY_SELECTION: 'web_clear_category_selection',
    WEB_HUNCH_TOP_BAR_REFRESH: 'web_hunch_top_bar_refresh',
    WEB_HUNCH_DOWNLOAD_CLICK: 'web_hunch_download_click',
    WEB_HUNCH_SESSION_TRACKER: 'web_hunch_session_tracker',
    WEB_HUNCH_WEBLINKS: 'web_hunch_weblinks',
    WEB_3S_POLL_VIEW: 'web_3s_poll_view',
    WEB_1S_POLL_VIEW: 'web_1s_poll_view',
    WEB_POLL_INTERACTION: 'web_poll_interaction',
    WEB_POLL_EXPANDED: 'web_poll_expanded',
    WEB_POLL_BROKEN: 'web_poll_broken'
});